export const _typeof =
  type =>
  // return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  obj =>
    Object.prototype.toString.call(obj) === `[object ${type}]`

export const isObject = _typeof('Object')

export const isString = _typeof('String')

export const isNumber = _typeof('Number')

export const isArray = obj => Array.isArray(obj)

export const isNonEmptyArray = (obj = []) =>
  obj && obj.length > 0 && Array.isArray(obj) && typeof obj !== 'undefined'
export const isEmptyObject = obj =>
  obj &&
  isObject(obj) &&
  Object.keys(obj).length === 0 &&
  obj.constructor === Object

/**
 * isPlainObject(node=document.getElementById("xx")) -> false
 * toString.call(node) : ie678 == '[object Object]',other =='[object HTMLElement]'
 * 'isPrototypeOf' in node : ie678 === false ,other === true
 * @param {*} obj
 */
export const isPlainObject = obj =>
  obj && isObject(obj) && 'isPrototypeOf' in obj

/**
 * 'null', 'undefined', '', null, undefined
 * @param {*} arg
 */
export const isNullOrEmpty = arg =>
  (typeof arg === 'string' &&
    (arg.toLowerCase() === 'null' || arg.toLowerCase() === 'undefined')) ||
  !!(!arg && arg !== 0 && typeof arg !== 'boolean')
/**
 * true,'true'=>true ; true=>true ;
 * false,'false'=>false; false=>false;
 * @param {string| number | boolean} bool
 */
export const isTrue = bool =>
  !isNullOrEmpty(bool) && /true/.test(bool.toString())

/**
 *  '1'=>true; 1=>true
 * '0'=>false;  0 =>false; 'xxxx'=>false; n=>false
 * @param {number,string} num
 */
export const Number2Boolean = num => isFinite(num) && +num === 1
/**
 * 比较2个对象是否相同
 * @param {o1,o2} Object
 */
export const isObjEqual = (o1, o2) => {
  const props1 = Object.getOwnPropertyNames(o1)
  const props2 = Object.getOwnPropertyNames(o2)
  if (props1.length !== props2.length) {
    return false
  }
  for (let i = 0, max = props1.length; i < max; i++) {
    const propName = props1[i]
    if (o1[propName] !== o2[propName]) {
      return false
    }
  }
  return true
}
